// Phase 6 — Track D T-D4. DateRangeFilter.
//
// Two date inputs + a Clear button. The current values are kept in URL
// search params so deep-links work and the back button restores filter
// state. The parent component owns the URL plumbing; this component
// is presentational + emits change events.

import * as React from 'react';
import { copy } from '@dailydeck/shared/copy';
import { Input } from '../../components/ui/Input.js';
import { Button } from '../../components/ui/Button.js';

export interface DateRangeFilterProps {
  from: string;
  to: string;
  onChange: (next: { from: string; to: string }) => void;
}

export function DateRangeFilter({ from, to, onChange }: DateRangeFilterProps): JSX.Element {
  const fromId = React.useId();
  const toId = React.useId();
  return (
    <div className="flex flex-wrap items-end gap-3" role="group" aria-label={copy.payments.filterLabel}>
      <div className="flex flex-col gap-1">
        <label htmlFor={fromId} className="text-caption text-text-secondary">
          {copy.payments.filterFromLabel}
        </label>
        <Input
          id={fromId}
          type="date"
          value={from}
          onChange={(e) => onChange({ from: e.target.value, to })}
          className="w-44"
        />
      </div>
      <div className="flex flex-col gap-1">
        <label htmlFor={toId} className="text-caption text-text-secondary">
          {copy.payments.filterToLabel}
        </label>
        <Input
          id={toId}
          type="date"
          value={to}
          onChange={(e) => onChange({ from, to: e.target.value })}
          className="w-44"
        />
      </div>
      <Button
        variant="secondary"
        type="button"
        onClick={() => onChange({ from: '', to: '' })}
        disabled={from === '' && to === ''}
      >
        {copy.payments.filterClear}
      </Button>
    </div>
  );
}
